// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Date = require("../../common/types/Date.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Utils = require("../../../utils/Utils.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_null = require("rescript/lib/js/js_null.js");
var V4 = require("uuid/v4");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var ApolloHooks = require("reason-apollo-hooks/src/ApolloHooks.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CurrentUser = require("../../common/CurrentUser/CurrentUser.bs.js");
var Types__User = require("../../user/Types__User.bs.js");
var ApolloClient = require("reason-apollo/src/ApolloClient.bs.js");
var Utils__Option = require("../../../utils/Utils__Option.bs.js");
var GraphQLHelpers = require("../../common/GraphQL/GraphQLHelpers.bs.js");
var TANApolloHooks = require("../../utils/apollo/TANApolloHooks.bs.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");
var Types__Attachment = require("../../common/types/Types__Attachment.bs.js");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var BroadcastMessage__Types = require("../../messages/types/BroadcastMessage__Types.bs.js");
var Conversations__ContextCard = require("../components/Conversations__ContextCard.bs.js");
var ConversationContext__Property = require("../types/ConversationContext__Property.bs.js");
var ConversationContext__BuyerNeed = require("../types/ConversationContext__BuyerNeed.bs.js");
var ConversationContext__RentalNeed = require("../types/ConversationContext__RentalNeed.bs.js");
var ConversationContext__RentalProperty = require("../types/ConversationContext__RentalProperty.bs.js");
var Conversations__GraphQL__FullConversation = require("./Conversations__GraphQL__FullConversation.bs.js");

function encode(x) {
  switch (x) {
    case /* Property */0 :
        return "PROPERTY";
    case /* BuyerNeed */1 :
        return "BUYER_NEED";
    case /* RentalProperty */2 :
        return "RENTAL_PROPERTY";
    case /* RentalNeed */3 :
        return "RENTAL_NEED";
    case /* BroadcastMessage */4 :
        return "BROADCAST_MESSAGE";
    
  }
}

function decode(x) {
  if (x === "BUYER_NEED") {
    return /* BuyerNeed */1;
  } else if (x === "RENTAL_NEED") {
    return /* RentalNeed */3;
  } else if (x === "PROPERTY") {
    return /* Property */0;
  } else if (x === "RENTAL_PROPERTY") {
    return /* RentalProperty */2;
  } else {
    return /* BroadcastMessage */4;
  }
}

var EntityType = {
  encode: encode,
  decode: decode
};

function decode$1(obj) {
  var variant = obj.NAME;
  var partial_arg = GraphQLConverter.Helpers.ok(variant === "RentalProperty" ? Belt_Result.map(obj.VAL, (function (i) {
                return {
                        TAG: /* RentalPropertySummary */4,
                        _0: i
                      };
              })) : (
          variant === "RentalNeed" ? Belt_Result.map(obj.VAL, (function (i) {
                    return {
                            TAG: /* RentalNeedSummary */5,
                            _0: i
                          };
                  })) : (
              variant === "PublicBuyerNeedContext" ? Belt_Result.map(obj.VAL.buyerNeed, (function (i) {
                        return {
                                TAG: /* PublicBuyerNeedSummary */2,
                                _0: i
                              };
                      })) : (
                  variant === "PrivatePropertyContext" ? Belt_Result.map(obj.VAL.property, (function (i) {
                            return {
                                    TAG: /* PrivatePropertySummary */1,
                                    _0: i
                                  };
                          })) : (
                      variant === "PublicPropertyContext" ? Belt_Result.map(obj.VAL.property, (function (i) {
                                return {
                                        TAG: /* PublicPropertySummary */0,
                                        _0: i
                                      };
                              })) : (
                          variant === "BroadcastMessageContext" ? Belt_Result.map(obj.VAL.broadcastMessage, (function (i) {
                                    return {
                                            TAG: /* BroadcastMessageSummary */6,
                                            _0: i
                                          };
                                  })) : Belt_Result.map(obj.VAL.buyerNeed, (function (i) {
                                    return {
                                            TAG: /* PrivateBuyerNeedSummary */3,
                                            _0: i
                                          };
                                  }))
                        )
                    )
                )
            )
        ));
  return GraphQLConverter.Helpers.run(function (i) {
                return i;
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap((function (param) {
                            return GraphQLConverter.Helpers.source(obj, param);
                          }), partial_arg, param);
            });
}

var ContextSummary = {
  decode: decode$1
};

function decode$2(obj) {
  var messages = Belt_Array.keepMap(obj.messages, Utils.Result.toOption);
  var func = GraphQLConverter.Converter.runConverter;
  var arg = function (id, visibility, latestMessage, messages, participants, context) {
    return {
            id: id,
            visibility: visibility,
            context: context,
            participants: participants,
            messages: messages,
            latestMessage: latestMessage
          };
  };
  var partial_arg = GraphQLConverter.Converter.$$const(function (obj) {
        return obj.participants;
      });
  var partial_arg$1 = GraphQLConverter.Converter.$$const(function (param) {
        return Belt_List.fromArray(messages);
      });
  var partial_arg$2 = GraphQLConverter.Converter.some((function (obj) {
          return Belt_Array.get(messages, obj.messages.length - 1 | 0);
        }), "decoded messages were []");
  var partial_arg$3 = GraphQLConverter.Converter.$$const(function (obj) {
        return obj.visibility;
      });
  var partial_arg$4 = GraphQLConverter.Converter.$$const(function (obj) {
        return obj.id;
      });
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Converter.source(obj, param);
                }), partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, partial_arg$3, param);
  };
  var partial_arg$7 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg$2, param);
  };
  var partial_arg$8 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$7, partial_arg$1, param);
  };
  var partial_arg$9 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$8, partial_arg, param);
  };
  var param = function (param$1) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$9, (function (param) {
                  return GraphQLConverter.Converter.ok((function (obj) {
                                return Utils__Option.transpose(Belt_Option.map(obj.context, decode$1));
                              }), param);
                }), param$1);
  };
  return Curry._2(func, param, arg);
}

var ConversationSummary = {
  decode: decode$2
};

function decodeConversationCount(v) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(v, (function (v) {
                    return v.results;
                  })), []).length;
}

var ppx_printed_query = "query conversationsCount($entityId: ID!, $entityType: ContextType!)  {\nconversationsCount: conversations(filter: {id: $entityId, type: $entityType})  {\nresults  {\nid  \n}\n\n}\n\n}\n";

function parse(value) {
  var value$1 = value["conversationsCount"];
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["results"];
    tmp = {
      results: !(value$2 == null) ? Js_array.map((function (value) {
                return {
                        id: value["id"]
                      };
              }), value$2) : undefined
    };
  }
  return {
          conversationsCount: decodeConversationCount(tmp)
        };
}

function json_of_ContextType(value) {
  if (value === "BUYER_NEED") {
    return "BUYER_NEED";
  } else if (value === "RENTAL_NEED") {
    return "RENTAL_NEED";
  } else if (value === "PROPERTY") {
    return "PROPERTY";
  } else if (value === "RENTAL_PROPERTY") {
    return "RENTAL_PROPERTY";
  } else {
    return "BROADCAST_MESSAGE";
  }
}

function make(entityId, entityType, param) {
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId
                    ],
                    [
                      "entityType",
                      json_of_ContextType(entityType)
                    ]
                  ])),
          parse: parse
        };
}

function makeWithVariables(variables) {
  var entityId = variables.entityId;
  var entityType = variables.entityType;
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId
                    ],
                    [
                      "entityType",
                      json_of_ContextType(entityType)
                    ]
                  ])),
          parse: parse
        };
}

function makeVariables(entityId, entityType, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "entityId",
                    entityId
                  ],
                  [
                    "entityType",
                    json_of_ContextType(entityType)
                  ]
                ]));
}

function definition_2(graphql_ppx_use_json_variables_fn, entityId, entityType, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [
                      [
                        "entityId",
                        entityId
                      ],
                      [
                        "entityType",
                        json_of_ContextType(entityType)
                      ]
                    ])));
}

var definition = [
  parse,
  ppx_printed_query,
  definition_2
];

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var GQL = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  json_of_ContextType: json_of_ContextType,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var ConversationsCount = {
  decodeConversationCount: decodeConversationCount,
  GQL: GQL
};

function decodeMaybeAnonymousUsers(arr) {
  return Belt_List.fromArray(Utils.$$Array.uniq(Belt_Array.keepMap(Belt_Array.map(arr, (function (x) {
                            if (x.NAME === "User") {
                              return Belt_Result.map(x.VAL, (function (u) {
                                            return /* User */{
                                                    _0: u
                                                  };
                                          }));
                            } else {
                              return {
                                      TAG: /* Ok */0,
                                      _0: /* AnonymousUser */0
                                    };
                            }
                          })), Utils.Result.toOption), (function (x) {
                    if (x) {
                      return x._0.id;
                    } else {
                      return "anonymous";
                    }
                  })));
}

var ppx_printed_query$1 = "fragment conversationSummary on Conversation   {\nid  \nvisibility  \nreadOnly  \nanonymous  \ncontext  {\n__typename\n...on PublicPropertyContext   {\nproperty  {\n..." + ConversationContext__Property.PropertyContextSummary.PropertyContextSummaryContextSummary__Property.name + "   \n}\n\n}\n\n...on PrivatePropertyContext   {\nproperty  {\n..." + ConversationContext__Property.PropertyContextSummary.PropertyContextSummaryContextSummary__Property.name + "   \n}\n\n}\n\n...on PublicBuyerNeedContext   {\nbuyerNeed  {\n..." + ConversationContext__BuyerNeed.BuyerNeedContextSummary.BuyerNeedContextSummaryContextSummary__BuyerNeed.name + "   \n}\n\n}\n\n...on PrivateBuyerNeedContext   {\nbuyerNeed  {\n..." + ConversationContext__BuyerNeed.BuyerNeedContextSummary.BuyerNeedContextSummaryContextSummary__BuyerNeed.name + "   \n}\n\n}\n\n...on RentalProperty   {\n..." + ConversationContext__RentalProperty.RentalPropertyContextSummary.RentalPropertyContextSummary__RentalProperty.name + "   \n}\n\n...on RentalNeed   {\n..." + ConversationContext__RentalNeed.RentalNeedContextSummary.RentalNeedContextSummaryContextSummary__RentalNeed.name + "   \n}\n\n...on BroadcastMessageContext   {\nbroadcastMessage  {\n..." + BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.name + "   \n}\n\n}\n\n}\n\nparticipants  {\n__typename\n...on User   {\n..." + Types__User.Fragment.User.name + "   \n}\n\n...on AnonymousUser   {\nid  \n}\n\n}\n\nmessages  {\n..." + Conversations__Types.Message.ConversationMessage.name + "   \n}\n\n}\n" + BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.query + ConversationContext__BuyerNeed.BuyerNeedContextSummary.BuyerNeedContextSummaryContextSummary__BuyerNeed.query + ConversationContext__Property.PropertyContextSummary.PropertyContextSummaryContextSummary__Property.query + ConversationContext__RentalNeed.RentalNeedContextSummary.RentalNeedContextSummaryContextSummary__RentalNeed.query + ConversationContext__RentalProperty.RentalPropertyContextSummary.RentalPropertyContextSummary__RentalProperty.query + Conversations__Types.Message.ConversationMessage.query + Types__User.Fragment.User.query;

function parse$1(value) {
  var value$1 = value["visibility"];
  var tmp = value$1 === "PUBLIC" ? "PUBLIC" : "PRIVATE";
  var value$2 = value["readOnly"];
  var value$3 = value["anonymous"];
  var value$4 = value["context"];
  var tmp$1;
  if (value$4 == null) {
    tmp$1 = undefined;
  } else {
    var typename_obj = Js_json.decodeObject(value$4);
    var tmp$2;
    if (typename_obj !== undefined) {
      var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
      if (typename !== undefined) {
        var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
        if (typename$1 !== undefined) {
          switch (typename$1) {
            case "BroadcastMessageContext" :
                tmp$2 = {
                  NAME: "BroadcastMessageContext",
                  VAL: {
                    broadcastMessage: Curry._1(BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.parse, value$4["broadcastMessage"])
                  }
                };
                break;
            case "PrivateBuyerNeedContext" :
                tmp$2 = {
                  NAME: "PrivateBuyerNeedContext",
                  VAL: {
                    buyerNeed: Curry._1(ConversationContext__BuyerNeed.BuyerNeedContextSummary.BuyerNeedContextSummaryContextSummary__BuyerNeed.parse, value$4["buyerNeed"])
                  }
                };
                break;
            case "PrivatePropertyContext" :
                tmp$2 = {
                  NAME: "PrivatePropertyContext",
                  VAL: {
                    property: Curry._1(ConversationContext__Property.PropertyContextSummary.PropertyContextSummaryContextSummary__Property.parse, value$4["property"])
                  }
                };
                break;
            case "PublicBuyerNeedContext" :
                tmp$2 = {
                  NAME: "PublicBuyerNeedContext",
                  VAL: {
                    buyerNeed: Curry._1(ConversationContext__BuyerNeed.BuyerNeedContextSummary.BuyerNeedContextSummaryContextSummary__BuyerNeed.parse, value$4["buyerNeed"])
                  }
                };
                break;
            case "PublicPropertyContext" :
                tmp$2 = {
                  NAME: "PublicPropertyContext",
                  VAL: {
                    property: Curry._1(ConversationContext__Property.PropertyContextSummary.PropertyContextSummaryContextSummary__Property.parse, value$4["property"])
                  }
                };
                break;
            case "RentalNeed" :
                tmp$2 = {
                  NAME: "RentalNeed",
                  VAL: Curry._1(ConversationContext__RentalNeed.RentalNeedContextSummary.RentalNeedContextSummaryContextSummary__RentalNeed.parse, value$4)
                };
                break;
            case "RentalProperty" :
                tmp$2 = {
                  NAME: "RentalProperty",
                  VAL: Curry._1(ConversationContext__RentalProperty.RentalPropertyContextSummary.RentalPropertyContextSummary__RentalProperty.parse, value$4)
                };
                break;
            default:
              tmp$2 = Js_exn.raiseError("Unexpected GraphQL query response");
          }
        } else {
          tmp$2 = Js_exn.raiseError("Unexpected GraphQL query response");
        }
      } else {
        tmp$2 = Js_exn.raiseError("Unexpected GraphQL query response");
      }
    } else {
      tmp$2 = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    tmp$1 = tmp$2;
  }
  var value$5 = value["participants"];
  var value$6 = value["messages"];
  return {
          id: value["id"],
          visibility: tmp,
          readOnly: !(value$2 == null) ? value$2 : undefined,
          anonymous: GraphQLHelpers.defaultToFalse(!(value$3 == null) ? value$3 : undefined),
          context: tmp$1,
          participants: decodeMaybeAnonymousUsers(Js_array.map((function (value) {
                      var typename_obj = Js_json.decodeObject(value);
                      if (typename_obj === undefined) {
                        return Js_exn.raiseError("Unexpected GraphQL query response");
                      }
                      var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
                      if (typename === undefined) {
                        return Js_exn.raiseError("Unexpected GraphQL query response");
                      }
                      var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
                      if (typename$1 === undefined) {
                        return Js_exn.raiseError("Unexpected GraphQL query response");
                      }
                      switch (typename$1) {
                        case "AnonymousUser" :
                            return {
                                    NAME: "AnonymousUser",
                                    VAL: {
                                      id: value["id"]
                                    }
                                  };
                        case "User" :
                            return {
                                    NAME: "User",
                                    VAL: Curry._1(Types__User.Fragment.User.parse, value)
                                  };
                        default:
                          return Js_exn.raiseError("Unexpected GraphQL query response");
                      }
                    }), value$5)),
          messages: Js_array.map((function (value) {
                  return Curry._1(Conversations__Types.Message.ConversationMessage.parse, value);
                }), value$6)
        };
}

var name = "conversationSummary";

function ret_type$1(f) {
  return {};
}

var MT_Ret$1 = {};

var ConversationSummary$1 = {
  ppx_printed_query: ppx_printed_query$1,
  query: ppx_printed_query$1,
  parse: parse$1,
  name: name,
  ret_type: ret_type$1,
  MT_Ret: MT_Ret$1
};

var Fragments = {
  ConversationSummary: ConversationSummary$1
};

function decode$3(v) {
  var x = GraphQLConverter.Helpers.reportErrors("errors decoding ConversationsSummary", "Conversations__GraphQL.res", 183, GraphQLConverter.Helpers.decodeRequired("results was None", (function (param) {
              return GraphQLConverter.Helpers.decodeArray(decode$2, param);
            }), v));
  if (x.TAG === /* Ok */0) {
    return x._0;
  } else {
    return [];
  }
}

var ppx_printed_query$2 = "query conversations($entityId: ID, $entityType: ContextType, $after: String, $limit: Int)  {\nconversations(filter: {id: $entityId, type: $entityType}, limit: $limit, after: $after)  {\nresults  {\n...conversationSummary   \n}\n\npageInfo  {\nlastCursor  \nhasNext  \n}\n\n}\n\n}\n" + ppx_printed_query$1;

function parse$2(value) {
  var value$1 = value["conversations"];
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["results"];
    var value$3 = value$1["pageInfo"];
    var value$4 = value$3["lastCursor"];
    tmp = {
      results: decode$3(!(value$2 == null) ? Js_array.map(parse$1, value$2) : undefined),
      pageInfo: {
        lastCursor: !(value$4 == null) ? value$4 : undefined,
        hasNext: value$3["hasNext"]
      }
    };
  }
  return {
          conversations: tmp
        };
}

function json_of_ContextType$1(value) {
  if (value === "BUYER_NEED") {
    return "BUYER_NEED";
  } else if (value === "RENTAL_NEED") {
    return "RENTAL_NEED";
  } else if (value === "PROPERTY") {
    return "PROPERTY";
  } else if (value === "RENTAL_PROPERTY") {
    return "RENTAL_PROPERTY";
  } else {
    return "BROADCAST_MESSAGE";
  }
}

function make$1(entityId, entityType, after, limit, param) {
  return {
          query: ppx_printed_query$2,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId !== undefined ? entityId : null
                    ],
                    [
                      "entityType",
                      entityType !== undefined ? json_of_ContextType$1(entityType) : null
                    ],
                    [
                      "after",
                      after !== undefined ? after : null
                    ],
                    [
                      "limit",
                      limit !== undefined ? limit : null
                    ]
                  ])),
          parse: parse$2
        };
}

function makeWithVariables$1(variables) {
  var entityId = variables.entityId;
  var entityType = variables.entityType;
  var after = variables.after;
  var limit = variables.limit;
  return {
          query: ppx_printed_query$2,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId !== undefined ? entityId : null
                    ],
                    [
                      "entityType",
                      entityType !== undefined ? json_of_ContextType$1(entityType) : null
                    ],
                    [
                      "after",
                      after !== undefined ? after : null
                    ],
                    [
                      "limit",
                      limit !== undefined ? limit : null
                    ]
                  ])),
          parse: parse$2
        };
}

function makeVariables$1(entityId, entityType, after, limit, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "entityId",
                    entityId !== undefined ? entityId : null
                  ],
                  [
                    "entityType",
                    entityType !== undefined ? json_of_ContextType$1(entityType) : null
                  ],
                  [
                    "after",
                    after !== undefined ? after : null
                  ],
                  [
                    "limit",
                    limit !== undefined ? limit : null
                  ]
                ]));
}

function definition_2$1(graphql_ppx_use_json_variables_fn, entityId, entityType, after, limit, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [
                      [
                        "entityId",
                        entityId !== undefined ? entityId : null
                      ],
                      [
                        "entityType",
                        entityType !== undefined ? json_of_ContextType$1(entityType) : null
                      ],
                      [
                        "after",
                        after !== undefined ? after : null
                      ],
                      [
                        "limit",
                        limit !== undefined ? limit : null
                      ]
                    ])));
}

var definition$1 = [
  parse$2,
  ppx_printed_query$2,
  definition_2$1
];

function ret_type$2(f) {
  return {};
}

var MT_Ret$2 = {};

var GQL$1 = {
  ppx_printed_query: ppx_printed_query$2,
  query: ppx_printed_query$2,
  parse: parse$2,
  json_of_ContextType: json_of_ContextType$1,
  make: make$1,
  makeWithVariables: makeWithVariables$1,
  makeVariables: makeVariables$1,
  definition: definition$1,
  ret_type: ret_type$2,
  MT_Ret: MT_Ret$2
};

function updateQuery(prevResult, updateQueryOptions) {
  return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.undefined_to_opt(updateQueryOptions.fetchMoreResult), (function (fetchMoreResult) {
                    return {
                            conversations: {
                              results: Belt_Array.concat(prevResult.conversations.results, Belt_Array.keep(fetchMoreResult.conversations.results, (function (newResult) {
                                          return !Belt_Array.some(prevResult.conversations.results, (function (prevResult) {
                                                        return prevResult.id === newResult.id;
                                                      }));
                                        }))),
                              pageInfo: fetchMoreResult.conversations.pageInfo,
                              __typename: prevResult.conversations.__typename
                            }
                          };
                  })), prevResult);
}

var FetchMore = {
  updateQuery: updateQuery
};

var ConversationsSummary = {
  decode: decode$3,
  GQL: GQL$1,
  FetchMore: FetchMore
};

var ppx_printed_query$3 = "query conversation($conversationId: ID!)  {\nconversation(id: $conversationId)  {\nid  \nmessages  {\n..." + Conversations__Types.Message.ConversationMessage.name + "   \n}\n\n}\n\n}\n" + Conversations__Types.Message.ConversationMessage.query;

function parse$3(value) {
  var value$1 = value["conversation"];
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["messages"];
    tmp = {
      id: value$1["id"],
      messages: Js_array.map((function (value) {
              return Curry._1(Conversations__Types.Message.ConversationMessage.parse, value);
            }), value$2)
    };
  }
  return {
          conversation: tmp
        };
}

function make$2(conversationId, param) {
  return {
          query: ppx_printed_query$3,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "conversationId",
                      conversationId
                    ]])),
          parse: parse$3
        };
}

function makeWithVariables$2(variables) {
  var conversationId = variables.conversationId;
  return {
          query: ppx_printed_query$3,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "conversationId",
                      conversationId
                    ]])),
          parse: parse$3
        };
}

function makeVariables$2(conversationId, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [[
                    "conversationId",
                    conversationId
                  ]]));
}

function definition_2$2(graphql_ppx_use_json_variables_fn, conversationId, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [[
                        "conversationId",
                        conversationId
                      ]])));
}

var definition$2 = [
  parse$3,
  ppx_printed_query$3,
  definition_2$2
];

function ret_type$3(f) {
  return {};
}

var MT_Ret$3 = {};

var GQL$2 = {
  ppx_printed_query: ppx_printed_query$3,
  query: ppx_printed_query$3,
  parse: parse$3,
  make: make$2,
  makeWithVariables: makeWithVariables$2,
  makeVariables: makeVariables$2,
  definition: definition$2,
  ret_type: ret_type$3,
  MT_Ret: MT_Ret$3
};

var Read = ApolloClient.ReadQuery({
      query: ppx_printed_query$3,
      parse: parse$3
    });

var Write = ApolloClient.WriteQuery({
      query: ppx_printed_query$3,
      parse: parse$3
    });

function useQuery(conversationId, skip, param) {
  return ApolloHooks.useQuery(undefined, Caml_option.some(makeVariables$2(conversationId, undefined)), undefined, undefined, undefined, skip, undefined, undefined, definition$2);
}

var ConversationMessagesQuery = {
  GQL: GQL$2,
  Read: Read,
  Write: Write,
  useQuery: useQuery
};

function decode$4(obj) {
  if (obj !== undefined) {
    return obj;
  } else {
    return {
            TAG: /* Error */1,
            _0: Curry._1(GraphQLConverter.Converter.$$Error.make, "conversation was null")
          };
  }
}

var ppx_printed_query$4 = "query conversation($conversationId: ID!)  {\nconversation(id: $conversationId)  {\n..." + Conversations__GraphQL__FullConversation.FullConversation.name + "   \n}\n\n}\n" + Conversations__GraphQL__FullConversation.FullConversation.query;

function parse$4(value) {
  var value$1 = value["conversation"];
  return {
          conversation: decode$4(!(value$1 == null) ? Conversations__GraphQL__FullConversation.FullConversation.parse(value$1) : undefined)
        };
}

function make$3(conversationId, param) {
  return {
          query: ppx_printed_query$4,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "conversationId",
                      conversationId
                    ]])),
          parse: parse$4
        };
}

function makeWithVariables$3(variables) {
  var conversationId = variables.conversationId;
  return {
          query: ppx_printed_query$4,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "conversationId",
                      conversationId
                    ]])),
          parse: parse$4
        };
}

function makeVariables$3(conversationId, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [[
                    "conversationId",
                    conversationId
                  ]]));
}

function definition_2$3(graphql_ppx_use_json_variables_fn, conversationId, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [[
                        "conversationId",
                        conversationId
                      ]])));
}

var definition$3 = [
  parse$4,
  ppx_printed_query$4,
  definition_2$3
];

function ret_type$4(f) {
  return {};
}

var MT_Ret$4 = {};

var GQL$3 = {
  ppx_printed_query: ppx_printed_query$4,
  query: ppx_printed_query$4,
  parse: parse$4,
  make: make$3,
  makeWithVariables: makeWithVariables$3,
  makeVariables: makeVariables$3,
  definition: definition$3,
  ret_type: ret_type$4,
  MT_Ret: MT_Ret$4
};

var include = ApolloClient.WriteQuery({
      query: ppx_printed_query$4,
      parse: parse$4
    });

function makeQueryResponse(conversation) {
  return {
          conversation: Caml_option.some(conversation)
        };
}

var Write_graphqlQueryAST = include.graphqlQueryAST;

var Write_make = include.make;

var Write$1 = {
  graphqlQueryAST: Write_graphqlQueryAST,
  make: Write_make,
  makeQueryResponse: makeQueryResponse
};

function useQuery$1(conversationId) {
  return ApolloHooks.useQuery(undefined, Caml_option.some(makeVariables$3(conversationId, undefined)), undefined, /* CacheAndNetwork */1, undefined, undefined, undefined, undefined, definition$3);
}

var ConversationQuery = {
  decode: decode$4,
  GQL: GQL$3,
  Write: Write$1,
  useQuery: useQuery$1
};

function decode$5(param) {
  return GraphQLConverter.Utils.reportOnDecoding("error decoding newConversationContext query", "Conversations__GraphQL.res", 309, Conversations__ContextCard.Context.decode, param);
}

var ppx_printed_query$5 = "query newConversationContext($entityId: ID!, $entityType: ContextType!)  {\nnewConversationContext(entityId: $entityId, entityType: $entityType)  {\n__typename\n...on PublicPropertyContext   {\nproperty  {\n..." + ConversationContext__Property.PropertyContext.PropertyContext.name + "   \n}\n\n}\n\n...on PrivatePropertyContext   {\nproperty  {\n..." + ConversationContext__Property.PropertyContext.PropertyContext.name + "   \n}\n\n}\n\n...on PublicBuyerNeedContext   {\nbuyerNeed  {\n..." + ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.name + "   \n}\n\n}\n\n...on PrivateBuyerNeedContext   {\nbuyerNeed  {\n..." + ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.name + "   \n}\n\n}\n\n...on RentalProperty   {\n..." + ConversationContext__RentalProperty.RentalPropertyContext.RentalRentalPropertyContext__RentalProperty.name + "   \n}\n\n...on RentalNeed   {\n..." + ConversationContext__RentalNeed.RentalNeedContext.RentalNeedContext__RentalNeed.name + "   \n}\n\n...on BroadcastMessageContext   {\nbroadcastMessage  {\n..." + BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.name + "   \n}\n\n}\n\n}\n\n}\n" + BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.query + ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.query + ConversationContext__Property.PropertyContext.PropertyContext.query + ConversationContext__RentalNeed.RentalNeedContext.RentalNeedContext__RentalNeed.query + ConversationContext__RentalProperty.RentalPropertyContext.RentalRentalPropertyContext__RentalProperty.query;

function parse$5(value) {
  var value$1 = value["newConversationContext"];
  var typename_obj = Js_json.decodeObject(value$1);
  var tmp;
  if (typename_obj !== undefined) {
    var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
    if (typename !== undefined) {
      var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
      if (typename$1 !== undefined) {
        switch (typename$1) {
          case "BroadcastMessageContext" :
              tmp = {
                NAME: "BroadcastMessageContext",
                VAL: {
                  broadcastMessage: Curry._1(BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.parse, value$1["broadcastMessage"])
                }
              };
              break;
          case "PrivateBuyerNeedContext" :
              tmp = {
                NAME: "PrivateBuyerNeedContext",
                VAL: {
                  buyerNeed: Curry._1(ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.parse, value$1["buyerNeed"])
                }
              };
              break;
          case "PrivatePropertyContext" :
              tmp = {
                NAME: "PrivatePropertyContext",
                VAL: {
                  property: Curry._1(ConversationContext__Property.PropertyContext.PropertyContext.parse, value$1["property"])
                }
              };
              break;
          case "PublicBuyerNeedContext" :
              tmp = {
                NAME: "PublicBuyerNeedContext",
                VAL: {
                  buyerNeed: Curry._1(ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.parse, value$1["buyerNeed"])
                }
              };
              break;
          case "PublicPropertyContext" :
              tmp = {
                NAME: "PublicPropertyContext",
                VAL: {
                  property: Curry._1(ConversationContext__Property.PropertyContext.PropertyContext.parse, value$1["property"])
                }
              };
              break;
          case "RentalNeed" :
              tmp = {
                NAME: "RentalNeed",
                VAL: Curry._1(ConversationContext__RentalNeed.RentalNeedContext.RentalNeedContext__RentalNeed.parse, value$1)
              };
              break;
          case "RentalProperty" :
              tmp = {
                NAME: "RentalProperty",
                VAL: Curry._1(ConversationContext__RentalProperty.RentalPropertyContext.RentalRentalPropertyContext__RentalProperty.parse, value$1)
              };
              break;
          default:
            tmp = Js_exn.raiseError("Unexpected GraphQL query response");
        }
      } else {
        tmp = Js_exn.raiseError("Unexpected GraphQL query response");
      }
    } else {
      tmp = Js_exn.raiseError("Unexpected GraphQL query response");
    }
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return {
          newConversationContext: decode$5(tmp)
        };
}

function json_of_ContextType$2(value) {
  if (value === "BUYER_NEED") {
    return "BUYER_NEED";
  } else if (value === "RENTAL_NEED") {
    return "RENTAL_NEED";
  } else if (value === "PROPERTY") {
    return "PROPERTY";
  } else if (value === "RENTAL_PROPERTY") {
    return "RENTAL_PROPERTY";
  } else {
    return "BROADCAST_MESSAGE";
  }
}

function make$4(entityId, entityType, param) {
  return {
          query: ppx_printed_query$5,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId
                    ],
                    [
                      "entityType",
                      json_of_ContextType$2(entityType)
                    ]
                  ])),
          parse: parse$5
        };
}

function makeWithVariables$4(variables) {
  var entityId = variables.entityId;
  var entityType = variables.entityType;
  return {
          query: ppx_printed_query$5,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId
                    ],
                    [
                      "entityType",
                      json_of_ContextType$2(entityType)
                    ]
                  ])),
          parse: parse$5
        };
}

function makeVariables$4(entityId, entityType, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "entityId",
                    entityId
                  ],
                  [
                    "entityType",
                    json_of_ContextType$2(entityType)
                  ]
                ]));
}

function definition_2$4(graphql_ppx_use_json_variables_fn, entityId, entityType, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [
                      [
                        "entityId",
                        entityId
                      ],
                      [
                        "entityType",
                        json_of_ContextType$2(entityType)
                      ]
                    ])));
}

var definition$4 = [
  parse$5,
  ppx_printed_query$5,
  definition_2$4
];

function ret_type$5(f) {
  return {};
}

var MT_Ret$5 = {};

var GQL$4 = {
  ppx_printed_query: ppx_printed_query$5,
  query: ppx_printed_query$5,
  parse: parse$5,
  json_of_ContextType: json_of_ContextType$2,
  make: make$4,
  makeWithVariables: makeWithVariables$4,
  makeVariables: makeVariables$4,
  definition: definition$4,
  ret_type: ret_type$5,
  MT_Ret: MT_Ret$5
};

function useQuery$2(entityId, entityType) {
  return ApolloHooks.useQuery(undefined, Caml_option.some(makeVariables$4(entityId, encode(entityType), undefined)), undefined, /* CacheAndNetwork */1, undefined, undefined, undefined, undefined, definition$4);
}

var ContextForNewConversation = {
  decode: decode$5,
  GQL: GQL$4,
  useQuery: useQuery$2
};

function makeOptimisticSenderInfo(senderInfo) {
  var match = senderInfo.membershipStatus;
  var avatar = senderInfo.avatar;
  return {
          id: senderInfo.id,
          firstName: senderInfo.firstName,
          lastName: senderInfo.lastName,
          company: senderInfo.company,
          displayName: Js_null.fromOption(senderInfo.displayName),
          email: senderInfo.email,
          phone: Js_null.fromOption(senderInfo.phone),
          membershipStatus: match === "TERMINATED" ? "TERMINATED" : "ACTIVE",
          city: null,
          account: Object.assign({
                __typename: "Account"
              }, senderInfo.account),
          avatar: Js_null.fromOption(avatar !== undefined ? ({
                    id: avatar.id,
                    key: avatar.key,
                    __typename: "Attachment"
                  }) : undefined),
          __typename: "User"
        };
}

function fromAttachment(v) {
  return {
          __typename: "Attachment",
          id: v.id,
          fileName: v.fileName,
          key: v.key,
          contentType: v.contentType
        };
}

var OptimisticAttachment = {
  fromAttachment: fromAttachment
};

function makeOptimisticMessage(senderInfo, text, images, files) {
  return {
          status: [],
          id: V4(),
          sentAt: $$Date.encodeAsFloat($$Date.now(undefined)),
          text: Belt_Option.getWithDefault(text, ""),
          images: Belt_Option.getWithDefault(Belt_Option.map(images, (function (is) {
                      return Belt_Array.map(is, fromAttachment);
                    })), []),
          files: Belt_Option.getWithDefault(Belt_Option.map(files, (function (fs) {
                      return Belt_Array.map(fs, fromAttachment);
                    })), []),
          sender: makeOptimisticSenderInfo(senderInfo),
          __typename: "ConversationMessage"
        };
}

var ppx_printed_query$6 = "mutation replyToConversation($input: ReplyToConversationInput!)  {\nreplyToConversation(input: $input)  {\nmessage  {\n..." + Conversations__Types.Message.ConversationMessage.name + "   \n}\n\n}\n\n}\n" + Conversations__Types.Message.ConversationMessage.query;

function parse$6(value) {
  var value$1 = value["replyToConversation"];
  var value$2 = value$1["message"];
  return {
          replyToConversation: {
            message: !(value$2 == null) ? Curry._1(Conversations__Types.Message.ConversationMessage.parse, value$2) : undefined
          }
        };
}

function json_of_AttachmentInput(value) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "id",
                    value.id
                  ],
                  [
                    "key",
                    value.key
                  ],
                  [
                    "fileName",
                    value.fileName
                  ],
                  [
                    "contentType",
                    value.contentType
                  ]
                ]));
}

function json_of_ReplyToConversationInput(value) {
  var v = value.text;
  var v$1 = value.images;
  var v$2 = value.files;
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "conversationId",
                    value.conversationId
                  ],
                  [
                    "text",
                    v !== undefined ? v : null
                  ],
                  [
                    "images",
                    v$1 !== undefined ? Js_array.map(json_of_AttachmentInput, v$1) : null
                  ],
                  [
                    "files",
                    v$2 !== undefined ? Js_array.map(json_of_AttachmentInput, v$2) : null
                  ]
                ]));
}

function make$5(input, param) {
  return {
          query: ppx_printed_query$6,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "input",
                      json_of_ReplyToConversationInput(input)
                    ]])),
          parse: parse$6
        };
}

function makeWithVariables$5(variables) {
  var input = variables.input;
  return {
          query: ppx_printed_query$6,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "input",
                      json_of_ReplyToConversationInput(input)
                    ]])),
          parse: parse$6
        };
}

function makeVariables$5(input, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [[
                    "input",
                    json_of_ReplyToConversationInput(input)
                  ]]));
}

function definition_2$5(graphql_ppx_use_json_variables_fn, input, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [[
                        "input",
                        json_of_ReplyToConversationInput(input)
                      ]])));
}

var definition$5 = [
  parse$6,
  ppx_printed_query$6,
  definition_2$5
];

function ret_type$6(f) {
  return {};
}

var MT_Ret$6 = {};

var GQL$5 = {
  ppx_printed_query: ppx_printed_query$6,
  query: ppx_printed_query$6,
  parse: parse$6,
  json_of_AttachmentInput: json_of_AttachmentInput,
  json_of_ReplyToConversationInput: json_of_ReplyToConversationInput,
  make: make$5,
  makeWithVariables: makeWithVariables$5,
  makeVariables: makeVariables$5,
  definition: definition$5,
  ret_type: ret_type$6,
  MT_Ret: MT_Ret$6
};

function makeOptimisticResponse(senderInfo, text, images, files) {
  return {
          __typename: "Mutation",
          replyToConversation: {
            __typename: "ReplyToConversationResponse",
            message: makeOptimisticMessage(senderInfo, text, images, files)
          }
        };
}

function useMutation(param) {
  return ApolloHooks.useMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, definition$5);
}

function makeVariables$6(conversationId, text, images, files, param) {
  return makeVariables$5({
              conversationId: conversationId,
              text: text,
              images: Belt_Option.map(images, (function (arr) {
                      return Belt_Array.map(arr, Types__Attachment.encode);
                    })),
              files: Belt_Option.map(files, (function (arr) {
                      return Belt_Array.map(arr, Types__Attachment.encode);
                    }))
            }, undefined);
}

var ReplyToConversationMutation = {
  GQL: GQL$5,
  makeOptimisticResponse: makeOptimisticResponse,
  useMutation: useMutation,
  makeVariables: makeVariables$6
};

var ppx_printed_query$7 = "mutation InitiateConversation($input: InitiateConversationInput!)  {\ninitiateConversation(input: $input)  {\nconversation  {\nid  \nvisibility  \nreadOnly  \nanonymous  \n..." + Conversations__ContextCard.Context.ConversationContext.name + "   \n..." + Conversations__Types.Participants.ConversationParticipants.name + "   \nmessages  {\n..." + Conversations__Types.Message.ConversationMessage.name + "   \n}\n\nevents  {\nid  \n}\n\n}\n\n}\n\n}\n" + Conversations__ContextCard.Context.ConversationContext.query + Conversations__Types.Message.ConversationMessage.query + Conversations__Types.Participants.ConversationParticipants.query;

function parse$7(value) {
  var value$1 = value["initiateConversation"];
  var value$2 = value$1["conversation"];
  var tmp;
  if (value$2 == null) {
    tmp = undefined;
  } else {
    var value$3 = value$2["visibility"];
    var tmp$1 = value$3 === "PUBLIC" ? "PUBLIC" : "PRIVATE";
    var value$4 = value$2["readOnly"];
    var value$5 = value$2["anonymous"];
    var value$6 = value$2["messages"];
    var value$7 = value$2["events"];
    tmp = {
      id: value$2["id"],
      visibility: tmp$1,
      readOnly: !(value$4 == null) ? value$4 : undefined,
      anonymous: GraphQLHelpers.defaultToFalse(!(value$5 == null) ? value$5 : undefined),
      context: Curry._1(Conversations__ContextCard.Context.ConversationContext.parse, value$2),
      participants: Curry._1(Conversations__Types.Participants.ConversationParticipants.parse, value$2),
      messages: Js_array.map((function (value) {
              return Curry._1(Conversations__Types.Message.ConversationMessage.parse, value);
            }), value$6),
      events: !(value$7 == null) ? Js_array.map((function (value) {
                return {
                        id: value["id"]
                      };
              }), value$7) : undefined
    };
  }
  return {
          initiateConversation: {
            conversation: tmp
          }
        };
}

function json_of_ContextType$3(value) {
  if (value === "BUYER_NEED") {
    return "BUYER_NEED";
  } else if (value === "RENTAL_NEED") {
    return "RENTAL_NEED";
  } else if (value === "PROPERTY") {
    return "PROPERTY";
  } else if (value === "RENTAL_PROPERTY") {
    return "RENTAL_PROPERTY";
  } else {
    return "BROADCAST_MESSAGE";
  }
}

function json_of_NewConversationContextInput(value) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "id",
                    value.id
                  ],
                  [
                    "type",
                    json_of_ContextType$3(value.type)
                  ]
                ]));
}

function json_of_ConversationVisibility(value) {
  if (value === "PUBLIC") {
    return "PUBLIC";
  } else {
    return "PRIVATE";
  }
}

function json_of_AttachmentInput$1(value) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "id",
                    value.id
                  ],
                  [
                    "key",
                    value.key
                  ],
                  [
                    "fileName",
                    value.fileName
                  ],
                  [
                    "contentType",
                    value.contentType
                  ]
                ]));
}

function json_of_InitiateConversationInput(value) {
  var v = value.visibility;
  var v$1 = value.anonymous;
  var v$2 = value.text;
  var v$3 = value.images;
  var v$4 = value.files;
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "context",
                    json_of_NewConversationContextInput(value.context)
                  ],
                  [
                    "visibility",
                    v !== undefined ? json_of_ConversationVisibility(v) : null
                  ],
                  [
                    "anonymous",
                    v$1 !== undefined ? v$1 : null
                  ],
                  [
                    "text",
                    v$2 !== undefined ? v$2 : null
                  ],
                  [
                    "images",
                    v$3 !== undefined ? Js_array.map(json_of_AttachmentInput$1, v$3) : null
                  ],
                  [
                    "files",
                    v$4 !== undefined ? Js_array.map(json_of_AttachmentInput$1, v$4) : null
                  ]
                ]));
}

function make$6(input, param) {
  return {
          query: ppx_printed_query$7,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "input",
                      json_of_InitiateConversationInput(input)
                    ]])),
          parse: parse$7
        };
}

function makeWithVariables$6(variables) {
  var input = variables.input;
  return {
          query: ppx_printed_query$7,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [[
                      "input",
                      json_of_InitiateConversationInput(input)
                    ]])),
          parse: parse$7
        };
}

function makeVariables$7(input, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [[
                    "input",
                    json_of_InitiateConversationInput(input)
                  ]]));
}

function definition_2$6(graphql_ppx_use_json_variables_fn, input, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [[
                        "input",
                        json_of_InitiateConversationInput(input)
                      ]])));
}

var definition$6 = [
  parse$7,
  ppx_printed_query$7,
  definition_2$6
];

function ret_type$7(f) {
  return {};
}

var MT_Ret$7 = {};

var GQL$6 = {
  ppx_printed_query: ppx_printed_query$7,
  query: ppx_printed_query$7,
  parse: parse$7,
  json_of_ContextType: json_of_ContextType$3,
  json_of_NewConversationContextInput: json_of_NewConversationContextInput,
  json_of_ConversationVisibility: json_of_ConversationVisibility,
  json_of_AttachmentInput: json_of_AttachmentInput$1,
  json_of_InitiateConversationInput: json_of_InitiateConversationInput,
  make: make$6,
  makeWithVariables: makeWithVariables$6,
  makeVariables: makeVariables$7,
  definition: definition$6,
  ret_type: ret_type$7,
  MT_Ret: MT_Ret$7
};

function makeOptimisticResponse$1(senderInfo, visibility, text, images, files, anonymous) {
  return {
          initiateConversation: {
            __typename: "InitiateConversationResponse",
            conversation: {
              __typename: "Conversation",
              id: V4(),
              visibility: visibility === "PUBLIC" ? "PUBLIC" : "PRIVATE",
              participants: [],
              readOnly: false,
              context: null,
              messages: [makeOptimisticMessage(senderInfo, text, images, files)],
              anonymous: anonymous,
              events: []
            }
          }
        };
}

function makeVariables$8(entityId, entityType, visibility, anonymous, text, images, files, param) {
  return makeVariables$7({
              context: {
                id: entityId,
                type: encode(entityType)
              },
              visibility: visibility,
              anonymous: anonymous,
              text: text,
              images: Belt_Option.map(images, (function (arr) {
                      return Belt_Array.map(arr, Types__Attachment.encode);
                    })),
              files: Belt_Option.map(files, (function (arr) {
                      return Belt_Array.map(arr, Types__Attachment.encode);
                    }))
            }, undefined);
}

var InitiateConversationMutation = {
  GQL: GQL$6,
  makeOptimisticResponse: makeOptimisticResponse$1,
  makeVariables: makeVariables$8
};

var ppx_printed_query$8 = "mutation markConversationMessagesAsRead($conversationId: ID!, $lastMessageId: ID!)  {\nmarkConversationMessagesAsRead(conversationId: $conversationId, lastMessageId: $lastMessageId)  {\nid  \nparticipant  {\n__typename\n...on User   {\nid  \n}\n\n...on AnonymousUser   {\nid  \n}\n\n}\n\nreadAt  \ndeliveredAt  \narchived  \n}\n\n}\n";

function parse$8(value) {
  var value$1 = value["markConversationMessagesAsRead"];
  return {
          markConversationMessagesAsRead: Js_array.map((function (value) {
                  var value$1 = value["participant"];
                  var tmp;
                  if (value$1 == null) {
                    tmp = undefined;
                  } else {
                    var typename_obj = Js_json.decodeObject(value$1);
                    var tmp$1;
                    if (typename_obj !== undefined) {
                      var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
                      if (typename !== undefined) {
                        var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
                        if (typename$1 !== undefined) {
                          switch (typename$1) {
                            case "AnonymousUser" :
                                tmp$1 = {
                                  NAME: "AnonymousUser",
                                  VAL: {
                                    id: value$1["id"]
                                  }
                                };
                                break;
                            case "User" :
                                tmp$1 = {
                                  NAME: "User",
                                  VAL: {
                                    id: value$1["id"]
                                  }
                                };
                                break;
                            default:
                              tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
                          }
                        } else {
                          tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
                        }
                      } else {
                        tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
                      }
                    } else {
                      tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
                    }
                    tmp = tmp$1;
                  }
                  var value$2 = value["readAt"];
                  var value$3 = value["deliveredAt"];
                  var value$4 = value["archived"];
                  return {
                          id: value["id"],
                          participant: tmp,
                          readAt: !(value$2 == null) ? Caml_option.some(value$2) : undefined,
                          deliveredAt: !(value$3 == null) ? Caml_option.some(value$3) : undefined,
                          archived: !(value$4 == null) ? value$4 : undefined
                        };
                }), value$1)
        };
}

function make$7(conversationId, lastMessageId, param) {
  return {
          query: ppx_printed_query$8,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "conversationId",
                      conversationId
                    ],
                    [
                      "lastMessageId",
                      lastMessageId
                    ]
                  ])),
          parse: parse$8
        };
}

function makeWithVariables$7(variables) {
  var conversationId = variables.conversationId;
  var lastMessageId = variables.lastMessageId;
  return {
          query: ppx_printed_query$8,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "conversationId",
                      conversationId
                    ],
                    [
                      "lastMessageId",
                      lastMessageId
                    ]
                  ])),
          parse: parse$8
        };
}

function makeVariables$9(conversationId, lastMessageId, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "conversationId",
                    conversationId
                  ],
                  [
                    "lastMessageId",
                    lastMessageId
                  ]
                ]));
}

function definition_2$7(graphql_ppx_use_json_variables_fn, conversationId, lastMessageId, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [
                      [
                        "conversationId",
                        conversationId
                      ],
                      [
                        "lastMessageId",
                        lastMessageId
                      ]
                    ])));
}

var definition$7 = [
  parse$8,
  ppx_printed_query$8,
  definition_2$7
];

function ret_type$8(f) {
  return {};
}

var MT_Ret$8 = {};

var GQL$7 = {
  ppx_printed_query: ppx_printed_query$8,
  query: ppx_printed_query$8,
  parse: parse$8,
  make: make$7,
  makeWithVariables: makeWithVariables$7,
  makeVariables: makeVariables$9,
  definition: definition$7,
  ret_type: ret_type$8,
  MT_Ret: MT_Ret$8
};

function use(param) {
  var match = ApolloHooks.useMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, definition$7);
  var mutate = match[0];
  var isImpersonated = CurrentUser.useIsImpersonated(undefined);
  return function (conversationId, lastMessageId) {
    if (isImpersonated) {
      return ;
    } else {
      Curry._6(mutate, Caml_option.some(make$7(conversationId, lastMessageId, undefined).variables), undefined, undefined, undefined, undefined, undefined);
      return ;
    }
  };
}

var MarkConversationAsReadMutation = {
  GQL: GQL$7,
  use: use
};

var ppx_printed_query$9 = "mutation setConversationAnonymousStatus($conversationId: ID!, $anonymous: Boolean!)  {\nsetConversationAnonymousStatus(conversationId: $conversationId, anonymous: $anonymous)  {\nid  \nanonymous  \n}\n\n}\n";

function parse$9(value) {
  var value$1 = value["setConversationAnonymousStatus"];
  var value$2 = value$1["anonymous"];
  return {
          setConversationAnonymousStatus: {
            id: value$1["id"],
            anonymous: !(value$2 == null) ? value$2 : undefined
          }
        };
}

function make$8(conversationId, anonymous, param) {
  return {
          query: ppx_printed_query$9,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "conversationId",
                      conversationId
                    ],
                    [
                      "anonymous",
                      anonymous
                    ]
                  ])),
          parse: parse$9
        };
}

function makeWithVariables$8(variables) {
  var conversationId = variables.conversationId;
  var anonymous = variables.anonymous;
  return {
          query: ppx_printed_query$9,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "conversationId",
                      conversationId
                    ],
                    [
                      "anonymous",
                      anonymous
                    ]
                  ])),
          parse: parse$9
        };
}

function makeVariables$10(conversationId, anonymous, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "conversationId",
                    conversationId
                  ],
                  [
                    "anonymous",
                    anonymous
                  ]
                ]));
}

function definition_2$8(graphql_ppx_use_json_variables_fn, conversationId, anonymous, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [
                      [
                        "conversationId",
                        conversationId
                      ],
                      [
                        "anonymous",
                        anonymous
                      ]
                    ])));
}

var definition$8 = [
  parse$9,
  ppx_printed_query$9,
  definition_2$8
];

function ret_type$9(f) {
  return {};
}

var MT_Ret$9 = {};

var GQL$8 = {
  ppx_printed_query: ppx_printed_query$9,
  query: ppx_printed_query$9,
  parse: parse$9,
  make: make$8,
  makeWithVariables: makeWithVariables$8,
  makeVariables: makeVariables$10,
  definition: definition$8,
  ret_type: ret_type$9,
  MT_Ret: MT_Ret$9
};

function use$1(param) {
  var match = TANApolloHooks.useMutation(undefined, undefined, undefined, undefined, undefined, undefined, definition$8);
  var mutate = match[0];
  return [
          (function (conversationId, anonymous) {
              return Curry._6(mutate, Caml_option.some(make$8(Conversations__Types.Conversation.idToString(conversationId), anonymous, undefined).variables), undefined, undefined, undefined, undefined, undefined);
            }),
          match[1]
        ];
}

var SetConversationAnonymousStatusMutation = {
  GQL: GQL$8,
  use: use$1
};

exports.EntityType = EntityType;
exports.ContextSummary = ContextSummary;
exports.ConversationSummary = ConversationSummary;
exports.ConversationsCount = ConversationsCount;
exports.decodeMaybeAnonymousUsers = decodeMaybeAnonymousUsers;
exports.Fragments = Fragments;
exports.ConversationsSummary = ConversationsSummary;
exports.ConversationMessagesQuery = ConversationMessagesQuery;
exports.ConversationQuery = ConversationQuery;
exports.ContextForNewConversation = ContextForNewConversation;
exports.makeOptimisticSenderInfo = makeOptimisticSenderInfo;
exports.OptimisticAttachment = OptimisticAttachment;
exports.makeOptimisticMessage = makeOptimisticMessage;
exports.ReplyToConversationMutation = ReplyToConversationMutation;
exports.InitiateConversationMutation = InitiateConversationMutation;
exports.MarkConversationAsReadMutation = MarkConversationAsReadMutation;
exports.SetConversationAnonymousStatusMutation = SetConversationAnonymousStatusMutation;
/* Read Not a pure module */
